import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminFetch } from "../../api/adminApi";
import { AdminCard, AdminPageHeader, SourceBadge } from "./AdminPageHeader";

export default function AdminFeed() {
  const [articles, setArticles] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const a = await adminFetch("/v1/admin/articles?limit=100");
        if (!cancelled) setArticles(a.articles || []);
        try {
          const c = await adminFetch("/v1/admin/customers");
          if (!cancelled) setCustomers(c.customers || []);
        } catch {
          /* writers */
        }
      } catch (e) {
        if (!cancelled) setErr(e.message);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div>
      <AdminPageHeader
        kicker="News"
        title="Article feed"
        description="The master copy for all articles. Edit an article to update the content across all clients, or select a specific client to customise their version."
      />

      {err && (
        <div className="mb-6 rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-300">
          {err}
        </div>
      )}

      <AdminCard noPadding className="overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-left">
            <thead>
              <tr className="border-b border-white/[0.06] bg-white/[0.03]">
                <th className="whitespace-nowrap px-4 py-3.5 text-left font-mono-data text-[10px] font-black uppercase tracking-[0.2em] text-slate-500">
                  Published
                </th>
                <th className="px-4 py-3.5 text-left font-mono-data text-[10px] font-black uppercase tracking-[0.2em] text-slate-500">
                  Headline
                </th>
                <th className="px-4 py-3.5 text-left font-mono-data text-[10px] font-black uppercase tracking-[0.2em] text-slate-500">
                  Source
                </th>
                <th className="px-4 py-3.5 text-right font-mono-data text-[10px] font-black uppercase tracking-[0.2em] text-slate-500">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {articles.map((row) => (
                <tr
                  key={row.id}
                  className="border-t border-white/[0.05] transition-colors hover:bg-[#CCFF00]/[0.04]"
                >
                  <td className="whitespace-nowrap px-4 py-4 font-mono-data text-xs text-slate-500">
                    {row.published_at}
                  </td>
                  <td className="max-w-md px-4 py-4">
                    <span className="line-clamp-2 font-medium text-slate-200">
                      {row.headline}
                    </span>
                  </td>
                  <td className="px-4 py-4">
                    <SourceBadge source={row.source} />
                  </td>
                  <td className="px-4 py-4 text-right">
                    <div className="flex flex-col items-end gap-2 sm:flex-row sm:flex-wrap sm:justify-end">
                      <Link
                        to={`/admin/article/${row.id}`}
                        className="inline-flex rounded-full border border-[#CCFF00]/35 bg-[#CCFF00]/[0.08] px-3 py-1.5 text-[10px] font-black uppercase tracking-widest text-[#CCFF00] transition-colors hover:bg-[#CCFF00]/20"
                      >
                        Edit canonical
                      </Link>
                      {customers.length > 0 &&
                        customers.map((c) => (
                          <Link
                            key={c.id}
                            to={`/admin/editor/${c.id}/${row.id}`}
                            className="inline-flex rounded-full border border-white/10 px-3 py-1.5 text-[10px] font-bold uppercase tracking-widest text-slate-400 transition-colors hover:border-white/20 hover:text-white"
                          >
                            {c.name}
                          </Link>
                        ))}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {articles.length === 0 && !err && (
          <p className="p-8 text-center text-sm text-slate-500">
            No articles yet. Run Goalise sync or publish from the console.
          </p>
        )}
      </AdminCard>
    </div>
  );
}